import React, { useEffect, useState } from "react";

import { Button, Container, Divider, Grid, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import MainHeader from "../MainHeader";
import Title from "../Title";
import EventsModalEdit from "../EventsModalEdit";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        overflow: "auto",
        ...theme.scrollbarStyles,
    },
    cardPaper: {
        padding: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        borderTop: "8px solid",
        borderTopColor: "#753c21",
    },
    title: {
        fontSize: "1.0rem",
    },
    description: {
        fontSize: "0.85rem",
    },
}));


const SelfScheduleList = () => {
    const classes = useStyles();

    const [loading, setLoading] = useState(false);
    const [selfScheduleData, setSelfScheduleData] = useState([]);
    const [open, setOpen] = useState(false);
    const [eventSelected, setEventSelected] = useState(null);

    useEffect(() => {
        setLoading(true);
        const fetchSelfSchedule = async () => {
            try {
                const { data } = await api.get("/selfschedules");

                const selfSchedule = data.filter(selfSchedule => selfSchedule.status === "AGENDADO");

                setSelfScheduleData(selfSchedule);

            } catch (error) {
                toastError(error);
            }
            setLoading(false);
        };

        fetchSelfSchedule();
    }, []);

    const handleOpenModal = async (selfSchedule) => {
        const event = await api.get(`/events/${selfSchedule.eventId}`);
        setEventSelected(event.data);
        setOpen(true);
    };

    const handleSelfScheduleAuthorized = (id) => {
        // Remove o selfSchedule da lista
        setSelfScheduleData(prevSchedules =>
            prevSchedules.filter(schedule => schedule.eventId !== id)
        );

        const selfSchedule = selfScheduleData.find(schedule => schedule.eventId === id);
        handelUpdateSelfSchedule(selfSchedule);

    };

    const handelUpdateSelfSchedule = async (selfSchedule) => {
        try {

            await api.put(`/selfschedules/${selfSchedule.id}`);
            toast.success("Agendamento autorizado com sucesso!");

        } catch (error) {
            toastError(error);
        }
    };

    return (
        <Container maxWidth="lg" className={classes.container}>
            {eventSelected && (
                <EventsModalEdit
                    open={open}
                    onClose={() => setOpen(false)}
                    event={eventSelected}
                    agendaName={eventSelected?.agenda?.name}
                    tab={"selfSchedule"}
                    onAuthorized={handleSelfScheduleAuthorized}
                />
            )}
            <MainHeader>
                <Title>Self Agendamentos</Title>
            </MainHeader>
            <Grid container spacing={2} alignContent="center" style={{ display: "flex", marginBottom: 16 }}>

                {!loading && selfScheduleData.length > 0 && (
                    <>
                        {selfScheduleData.map((selfSchedule) => (
                            <Grid item xs={3} key={selfSchedule.id}>
                                <Paper className={classes.cardPaper} elevation={3}>
                                    <Grid container spacing={1} direction="column" alignContent="left">
                                        <Grid item>
                                            <Typography variant="h6" className={classes.title}>Agendamento por</Typography>
                                            <Typography variant="body1" className={classes.description}>{selfSchedule.contact.name}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h6" className={classes.title}>Agenda</Typography>
                                            <Typography variant="body1" className={classes.description}>{selfSchedule.agenda.name}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h6" className={classes.title}>Data</Typography>
                                            <Typography variant="body1" className={classes.description}>{selfSchedule.date}</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h6" className={classes.title}>Horário</Typography>
                                            <Typography variant="body1" className={classes.description}>{selfSchedule.start}</Typography>
                                        </Grid>
                                        <Divider />
                                        <Grid item style={{ marginLeft: "auto" }}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => handleOpenModal(selfSchedule)}
                                            >
                                                Autorizar agendamento
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        ))}
                    </>
                )}
            </Grid>
        </Container>
    );
};

export default SelfScheduleList;